export default "__VITE_ASSET__D45Q82DZ__"